import React, { useState } from "react";
import "./studentSideBar.css";
import LiveClassWorkshop from "./studentComponents/liveClassWorkShop";
import InternshipPageContent from "./studentComponents/InternShipPageContent";
import BookListingPage from "./studentComponents/booksContentPage";
import OrderPage from "./studentComponents/ordersPage";

const StudentSideBar = () => {
  const [selectedPage, setSelectedPage] = useState("liveClassWorkshop");

  const renderContent = () => {
    switch (selectedPage) {
      case "liveClassWorkshop":
        return <LiveClassWorkshop />;
      case "internshipPage":
        return <InternshipPageContent />;
      case "booksPage":
        return <BookListingPage />;
      case "ordersPage":
        return <OrderPage />;
      default:
        return <LiveClassWorkshop />;
    }
  };

  const getTabStyle = (pageName) => {
    return selectedPage === pageName
      ? { fontWeight: "bold", color: "#3498db", backgroundColor: "#ecf0f1", borderRadius: "5px" }
      : {};
  };

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <div className="sidebarContainer">
        <ul className="submenuClient">
          <p>Home Page</p>
          <li
            style={getTabStyle("liveClassWorkshop")}
            onClick={() => setSelectedPage("liveClassWorkshop")}
          >
            Live Class & Workshops
          </li>
          <p>Internship</p>
          <li
            style={getTabStyle("internshipPage")}
            onClick={() => setSelectedPage("internshipPage")}
          >
            Internship Page
          </li>
          <p>Library</p>
          <li
            style={getTabStyle("booksPage")}
            onClick={() => setSelectedPage("booksPage")}
          >
            Books
          </li>
          <li
            style={getTabStyle("ordersPage")}
            onClick={() => setSelectedPage("ordersPage")}
          >
            Orders
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="contentContainer">{renderContent()}</div>
    </div>
  );
};

export default StudentSideBar;
